import { takeLatest, call, put, all } from 'redux-saga/effects';
import { toast } from 'react-toastify';

import history from '~/services/history';
import api from '~/services/api';

import { saveMr1Failure, saveMr1Success, updateMr1Failure, updateMr1Success } from './actions';

export function* saveMr1({ payload }) {
  try {
    yield call(api.post, 'api/mr1', payload.data, { withCredentials: true });

    yield put(saveMr1Success());

    toast.success('MR1 criado com sucesso!')

    history.push('/specifications/pilar3/resources/mr1');
  } catch (error) {
    if (error?.response?.data?.message) {
      toast.error(error.response.data.message);
    } else if (error?.message) {
      toast.error(error.message);
    } else {
      toast.error('Ocorreu um erro inesperado. Tente novamente.');
    }
    yield put(saveMr1Failure());
  }
}

export function* updateMr1({ payload }) {
  try {
    const { id } = payload.data;
    yield call(api.post, `api/mr1/${id}`, payload.data, { withCredentials: true });

    yield put(updateMr1Success());

    toast.success('MR1 atualizado com sucesso!')

    history.push('/specifications/pilar3/resources/mr1');
  } catch (error) {
    if (error?.response?.data?.message) {
      toast.error(error.response.data.message);
    } else if (error?.message) {
      toast.error(error.message);
    } else {
      toast.error('Ocorreu um erro inesperado. Tente novamente.');
    }
    yield put(updateMr1Failure());
  }
}

export default all([
  takeLatest('@mr1/SAVE_REQUEST', saveMr1),
  takeLatest('@mr1/UPDATE_REQUEST', updateMr1)
]);